import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';

type CustomDatePickerProps = {
  label?: string;
  value?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
};

const CustomDatePicker = (props: CustomDatePickerProps) => {
  const styles = {
    '& .MuiInputBase-root input': {
      cursor: 'pointer',
    },
  };

  const handleChange = (date: Dayjs | null) => {
    if (date) {
      props.onChange(date.format('YYYY-MM-DD'));
    }
  };

  return (
    <>
      <Typography color="primary" variant={'h6'}>
        {props.label}
      </Typography>
      <MobileDatePicker
        format="DD.MM.YYYY"
        defaultValue={props?.value ? dayjs(new Date(props.value)) : undefined}
        onChange={(e) => handleChange(e)}
        data-testid={'custom-date-picker'}
        disabled={props?.disabled}
        sx={styles}
      />
    </>
  );
};

export default CustomDatePicker;
